import React from 'react';
import { Tooltip, CircularProgress, IconButton } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import useTeamProvider from './useTeamProvider';

export default function CustomToolbar({ isTableDataLoading }) {
  const { hideActionButtons, isDataLoading, handleServerAction, refreshTable } = useTeamProvider();

  return (
    <React.Fragment>
      {!hideActionButtons && (
        <div className="table-custom-actions">
          {isDataLoading ? (
            <IconButton size="small" className="search-icon">
              <CircularProgress size={18} color="inherit" />
            </IconButton>
          ) : (
            <IconButton onClick={() => handleServerAction()}>
              <span className="table-action-text" style={{ marginTop: '8px' }}>
                {'Send All'}
              </span>
            </IconButton>
          )}
        </div>
      )}
      {isTableDataLoading && (
        <IconButton style={{ order: 10 }}>
          <CircularProgress size={18} />
        </IconButton>
      )}
      {!isTableDataLoading && (
        <Tooltip title={'Refresh'}>
          <IconButton style={{ order: 10 }} onClick={refreshTable}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      )}
    </React.Fragment>
  );
}
